angular.module('impactx.catalog').controller('CatalogActionDialogCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'dataGen',
    'catId',
    'atiIds',
    'action',
    CatalogActionDialogCtrl]);

function CatalogActionDialogCtrl($scope, $mdDialog, themeFactory, dataGen, catId, atiIds, action)
{
    var self = this;
    
    $scope.dateInPast = false;
    $scope.theme = themeFactory.getTheme();
    
    this.getData = function(){
        var params = {
            params: {
                catId: catId,
                atiIds: atiIds,
                action: action
            }
        };
        dataGen.postAsForm($scope, params, "/catalog/approvalaction");
    };
    

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.answer = function ()
    {
        var result = {
            comment: $scope.data.comment.value
        };
        if ($scope.data.plannedReleaseType && $scope.data.plannedReleaseType.setId === 2) {
            result.actionDate = $scope.data.plannedReleaseDate;
        }
        $mdDialog.hide(result);
    };

    this.getData();
}